import { html } from "../../render";
import { attr, cn, spreadAttrs } from "../../utils";
import { LpButton } from "../button";
const paginationManagedAttrs = [
    "data-lp-component",
    "class",
    "aria-label",
];
const pageListManagedAttrs = [
    "class",
];
export function LpPagination({ ariaLabel = "Pagination", pages, className, attributes, firstAttributes, lastAttributes, pageListAttributes, }) {
    return html `
        <nav
            data-lp-component="Pagination"
            class="${cn("lp-pagination", className, attributes?.class)}"
            ${attr("aria-label", ariaLabel)}
            ${spreadAttrs(attributes, { omit: paginationManagedAttrs })}
        >
            ${LpButton({
        ariaLabel: "First page",
        prefixIcon: "caret-double-left",
        variant: "ghost",
        size: "sm",
        shape: "square",
        className: "lp-pagination_nav",
        attributes: firstAttributes,
    })}
            <ul
                class="${cn("lp-pagination_pages", pageListAttributes?.class)}"
                ${spreadAttrs(pageListAttributes, { omit: pageListManagedAttrs })}
            >
                ${pages ?? html `
                    <li class="lp-pagination_page-item">
                        <button
                            type="button"
                            class="lp-pagination_page"
                            data-bind="css: { 'is-active': isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }"
                        ></button>
                    </li>
                `}
            </ul>
            ${LpButton({
        ariaLabel: "Last page",
        prefixIcon: "caret-double-right",
        variant: "ghost",
        size: "sm",
        shape: "square",
        className: "lp-pagination_nav",
        attributes: lastAttributes,
    })}
        </nav>
    `;
}
